<!-- 状态监视 -->
<template>
	<div style="height: 100%">
		<!-- 中 -->
		<div style="margin-right: 10px;">
      <div class="selectBox">
        <div class="selectChoose">
          <div class="selectTexts" style="width: 70px">
            <p>{{$t('label_501')}}</p>
          </div>
          <el-select v-model="sortName">
  <!--          <el-option label="稼动率" value="activation">-->
  <!--          </el-option>-->
            <el-option :label="$t('label_194')" value="code">
            </el-option>
          </el-select>
        </div>
        <div style="display: flex;align-items:center">
          <el-radio-group v-model="sort" @input="search">
            <el-radio label="ASC">{{$t('label_526')}}</el-radio>
            <el-radio label="DESC">{{$t('label_528')}}</el-radio>
          </el-radio-group>
        </div>
      </div>
<!--      <div class="selectBox">-->
<!--        <div class="selectChoose">-->
<!--          <div class="selectText">-->
<!--            <p>设备编号</p>-->
<!--          </div>-->
<!--          <div class="select" style="width:350px">-->
<!--            <el-input-->
<!--              v-model="deviceCode"-->
<!--              clearable-->
<!--              @change="search">-->
<!--            </el-input>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
			<div style="float: right;">
				<div style="float: left;" :style="{background:$store.getters.getColor['1'].color}" class="checkBoxs"></div>&nbsp;
				<span style="margin-right: 10px;">{{$t('label_152')}}</span>
			</div>
			<div style="float: right;">
				<div style="float: left;" :style="{background:$store.getters.getColor['2'].color}" class="checkBoxs"></div>&nbsp;
				<span style="margin-right: 10px;">{{$t('btn_24')}}</span>
			</div>
			<div style="float: right;">
				<div style="float: left;" :style="{background:$store.getters.getColor['3'].color}" class="checkBoxs"></div>&nbsp;
				<span style="margin-right: 10px;">{{$t('label_561')}}</span>
			</div>
		</div>
		<div style="height:calc(100% - 35px)">
			<el-table :empty-text="$t('label_357')" v-loading="loading" ref="singleTable" :data="selectEquipmentList" highlight-current-row @current-change="handleCurrentChangeTree"
			 border style="width: 100%;margin: 10px 0" height="100%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
				<el-table-column prop="name" :label="$t('label_156')" align="left" width="150">
					<template slot-scope="scope">
						<div>
							<img v-if="scope.row.img!=null" style="width: 100%;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+scope.row.img"
							 :onerror="defaultImg">
							 <img v-else style="width: 100%;" src="../../../assets/img/deviceDefaultImg.png"/>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="type" :label="$t('label_1') + 'ID/' + $t('label_297') + '/' + $t('label_161')" align="left" width="250">
					<template slot-scope="scope" style="text-align: center;">
						<div style="cursor: pointer;" @click="detailShow(scope.row)">
							<span style="font-size: 18px;font-weight: 600;">
								{{(scope.row.code==null?'':scope.row.code)}}&nbsp;{{scope.row.companyNumber==null?'':'<'+scope.row.companyNumber+'>'}}<br />
							</span>
							<span style="font-size: 18px;font-weight: 600;">
								{{(scope.row.code==null?'':scope.row.code)}}&nbsp;{{scope.row.name}}
							</span>
						</div>
						<span style="font-size: 14px;font-weight: 600;">
							{{scope.row.superior}}
						</span>

					</template>
				</el-table-column>
				<el-table-column prop="id" :label="$t('label_166')" align="left">
					<template slot-scope="scope">
						<!-- 性能分析图 -->
						<div class="deviceTime" style="width: 100%;height: 120px;margin-top:4px;">
							<TimeChart v-if="pageChange" :chartsId="'deviceTime'+scope.row.id" :dataCode="scope.row.code" :dataName="scope.row.name"
							 :data="timeChartData[scope.row.id]" :beginTime="beginTime" :endTime="endTime" :tableWidth="tableWidth"></TimeChart>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- <div style="position: absolute;bottom: 0px;left: 30%">
			<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
			 @parentMethod="searchPage"></Page>
		</div> -->
	</div>
</template>
<script>
	import file from "@/assets/js/file/file.js";
	import Page from "@/components/common/pageNew2";
	import popMesBox from "@/components/list/popover/pop";
	import utils from '@/utils/utils';
	import * as echarts from 'echarts';
	import TimeChart from '@/components/list/chart/timeChart';
	import signal from "@/assets/js/signal/signal.js";
	import equipmentMonitoringService from "@/assets/js/signal/equipmentMonitoringService.js";
	import exportMes from "@/components/list/export/export";
	import $ from 'jquery'
	export default {
		name: "stateParam",
		components: {
			utils,
			file,
			Page,
			popMesBox,
			TimeChart,
		},

		data() {

			return {
				loading: false,
				defaultImg: 'this.src="' + require('@/assets/img/deviceDefaultImg.png') + '"',
				name: 'StateParam',
				checked: true,
				isSave: false,
				isSelected: [],
				value: '',
				radio: [],
				value1: [],
				value2: [],
				selectTimeList: [],
				selectEquipmentList: [],
				tableParamData: [{}],
				pageNum: 1,
				pageSize: 10,
				MenuRoleList: [],
				checkMesList: [{
					value: ''
				}],
				tableData1: [],
				tableDataTreeInfo: {},
				pageCount: 0,
				unitList: [],
				searchData: {
					type: 2,
					id: 0,
					valueList: []
				},
				searchDataList: {
					id: '0',
					type: 2
				},
				beginTime: '',
				endTime: '',
				timeChartData: {},
				pageChange: true,
				tableWidth: 0,
				allWidth:0,
        // deviceCode: '',
        sortName: 'code',
        sort: 'ASC',
			}
		},
		methods: {
			//显示设备详细信息
			detailShow: function(data) {
				this.$emit('detailShow', data);
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},

			handleCurrentChangeTreeTime(info) {
				this.tableChooseInfo = info;
			},
			selectEquipment(param) {
				this.pageChange = false;
				this.$nextTick(function() {
					this.pageChange = true;
				})
				var $this = this;
				console.log(param)
				equipmentMonitoringService.selectEquipmentById(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.selectEquipmentList = data.data;
						this.loading = false;
						$('.el-table__body-wrapper').animate({
							scrollTop: 0
						}, 400);
						//定时查询数据
						$this.selectTime($this.selectEquipmentList);
						utils.clearTime();
						utils.timing(function() {
							$this.selectTime($this.selectEquipmentList);
						}, 10000)
					};
				}).catch((response) => {
					console.log(response)
				})
			},
			selectTime(param) {
				// console.log(param)
				equipmentMonitoringService.selectTime(param, this.beginTime, this.endTime).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.timeChartData = data.data;
					};
				}).catch((response) => {
					console.log(response)
				})
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			newMes(data, beginTime, endTime, code) {
				this.beginTime = beginTime;
				this.endTime = endTime;
				this.searchDataList.id = data.id;
				this.searchDataList.type = data.type;
				this.tableWidth = this.$refs.singleTable.bodyWidth.substring(0, this.$refs.singleTable.bodyWidth.length - 2) - 440
        // this.deviceCode = code
				this.search();
			},
			newMes2(w) {
				this.tableWidth = this.$refs.singleTable.bodyWidth.substring(0, this.$refs.singleTable.bodyWidth.length - 2) - 440 + w
				this.pageChange = false;
				this.$nextTick(function() {
					this.pageChange = true;
				})
			},
			searchPage(param) {
				let dataParam = this.searchDataList;
				// this.$set(dataParam, 'code', this.deviceCode);
        this.$set(dataParam, 'sortName', this.sortName);
        this.$set(dataParam, 'sort', this.sort);
				let newParam = Object.assign(param, dataParam);
				this.loading = true;
				this.selectEquipment(dataParam);
			},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param)
			},

			resizeChart() {
				let n=document.body.clientWidth-this.allWidth
				this.allWidth=document.body.clientWidth
				this.tableWidth = this.$refs.singleTable.bodyWidth.substring(0, this.$refs.singleTable.bodyWidth.length - 2) - 440 + n
				this.pageChange = false;
				this.$nextTick(function() {
					this.pageChange = true;
				})
			},
			test2(w) {
				this.tableWidth = this.$refs.singleTable.bodyWidth.substring(0, this.$refs.singleTable.bodyWidth.length - 2) - 440 + w
				this.pageChange = false;
				this.$nextTick(function() {
					this.pageChange = true;
				})
			},
			getWorkTime: function() {
				equipmentMonitoringService.getWorkTime().then((response) => {
					const data = response.data;
					if (data.code == "1") {
							this.beginTime = data.data.beginTime;
							this.endTime = data.data.endTime;
					};
				}).catch((response) => {
					console.log(response)
				})
			},
		}, //methods的闭合
		mounted() {
			window.test2 = this.test2;
			window.addEventListener('resize', this.resizeChart, true)
		},
		created() {
			this.timer = setInterval(() => {
				this.getWorkTime();
			}, 1000)
			this.allWidth=document.body.clientWidth
			this.MenuRoleList = this.$store.getters.getMenu;
		},

		beforeDestroy() {
			clearInterval(this.timer);
			this.timer = null;
			utils.clearTime();
		}
	}
</script>

<style>
	/* 	.echart_style {
		width: 95%;
		height: 230px;
	} */

	.stateDiagram {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 20px;
	}

	.box_down_all_style {
		display: flex;
	}

	/*  .box_down_all_left {
    width: 39%;
    border-bottom: 1px solid #EFEFEF;
  }

  .box_down_all_right {
    width: 60%;
  } */

	.tableBox_aaaa {
		margin-top: 15px;
	}

	.tableBox_two {
		margin-left: 24px;
	}

	.tableBox_two .el-table td,
	.tableBox_two .el-table th {
		padding: 5px;
	}

	.tableBox_aaaa .el-table td,
	.tableBox_aaaa .el-table th {
		padding: 1px;
	}

	.lft_box {
		font-size: 18px;
		font-weight: bold;
	}

	.lft_text {
		font-size: 18px;
		font-weight: bold;
		margin-top: 15px;
		margin-left: 30px;
	}

	.sype_title {
		font-size: 20px;
		font-weight: bold;
		margin-left: 30px;
	}

	.tablebox_down {
		width: 40%;
	}

	.sec_box .secBox_one.check {
		border: 1px solid #3fb393;
	}

	.sec_box .secBox_one {
		border: 1px solid #DADADA;
		background: #EFEFEF;
		width: 22%;
		height: 40px;
		margin-left: 25px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.secBox_one p {
		padding-left: 10px;
		line-height: 40px;
		font-weight: bold;
	}

	.checkBox {
		margin-right: 10px;
	}

	.group-inp {
		width: 100px;
	}

	.secBox {
		width: 10px;
		height: 10px;
	}

	.conBox {
		display: flex;
		align-items: center;
	}

	.secBox_one {
		display: flex;
		width: 15px;
		height: 15px;
		margin-top: 5px;
	}

	.table_box .el-table td,
	.table_box .el-table th {
		padding: 3px;
	}
</style>



// WEBPACK FOOTER //
// src/components/list/monitoring/stateParam.vue